import { render } from "./CreditsOverview.vue?vue&type=template&id=5be5ba60&scoped=true&ts=true"
import script from "./CreditsOverview.vue?vue&type=script&lang=ts"
export * from "./CreditsOverview.vue?vue&type=script&lang=ts"

import "./CreditsOverview.vue?vue&type=style&index=0&id=5be5ba60&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be5ba60"]])

export default __exports__